import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PriceGroup } from '../../model/price-group.model';

@Component({
    selector: 'app-contract-price-group',
    templateUrl: './contract-price-group.component.html',
    styleUrls: ['./contract-price-group.component.scss'],
    standalone: false
})
export class ContractPriceGroupComponent {
  @Input() priceGroup: PriceGroup;
  @Output() priceGroupSelectedEvent = new EventEmitter<PriceGroup>();
  priceGroupSelected: PriceGroup;

  selectPriceGroup(e): void {
    this.priceGroupSelectedEvent.emit(e);
  }
}
